import React from "react";
import Context from "../../../../../Context";
import { Modal } from "react-bootstrap";
import Blocker from "../../../../Misc/Blocker";

export default class AddModal extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);

    let defaultValues = {
      name: "",
      data: "",
      type: 0,
      subkey: this.props.subkey,
      key: this.props.pkey,
    };
    this.state = {
      input: defaultValues,
      default: defaultValues,
      pending: false,
    };
  }

  save = async () => {
    this.setState({ pending: true });

    let result = await this.context.api.q("/registry/write", this.state.input);
    if (result !== false) {
      this.context.toast(`Ключ реестра успешно создан `, "success");
      this.hide();
    } else {
      this.context.toast(`Не удалось создать ключ реестра `, "error");
    }
    this.props.onAdd();
    this.setState({ pending: false });
  };

  hide = () => {
    this.setState({ input: this.state.default });
    this.props.onHide();
  };

  input = (id, value) => {
    this.setState((state) => {
      let input = state.input;
      input[id] = value;
      return { input };
    });
  };

  render() {
    let valueInput = (
      <input
        className="form-control"
        id="data"
        onChange={(e) => this.input(e.target.id, e.target.value)}
      />
    );
    let valueSelect = (
      <select
        className="form-control"
        id="data"
        value={this.state.input.data}
        onChange={(e) => this.input("data", e.target.value)}
      >
        <option></option>
        <option value="true">Да</option>
        <option value="false">Нет</option>
      </select>
    );
    return (
      <Modal size="lg" onHide={this.hide} show={this.props.show}>
        <Blocker on={this.state.pending}>
          <Modal.Header closeButton>
            <Modal.Title>Добавление ключа</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Ключ</label>
                  <select
                    className="form-control"
                    id="key"
                    value={this.state.input.key}
                    onChange={(e) => this.input(e.target.id, e.target.value)}
                  >
                    <option value="CURRENT_CONFIG">CURRENT_CONFIG</option>
                    <option value="CURRENT_USER">CURRENT_USER</option>
                  </select>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Подключ (путь)</label>
                  <input
                    className="form-control"
                    id="subkey"
                    value={this.state.input.subkey}
                    onChange={(e) => this.input(e.target.id, e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Тип значения</label>
                  <select
                    className="form-control"
                    id="type"
                    value={this.state.input.type}
                    onChange={(e) => {
                      this.input(e.target.id, e.target.value);
                      this.input("data", "");
                    }}
                  >
                    <option value="0">Целый</option>
                    <option value="1">Числовой</option>
                    <option value="2">Дата и время</option>
                    <option value="3">Строка</option>
                    <option value="4">Да / Нет</option>
                  </select>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Имя значения</label>
                  <input
                    className="form-control"
                    id="name"
                    onChange={(e) => this.input(e.target.id, e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="form-group" key={this.state.input.type}>
              <label>Значение</label>
              {this.state.input.type === "4" ? valueSelect : valueInput}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-primary" onClick={this.save}>
              Сохранить
            </button>
            <button className="btn btn-secondary" onClick={this.hide}>
              Отмена
            </button>
          </Modal.Footer>
        </Blocker>
      </Modal>
    );
  }
}
